import { useCallback, useEffect, useState } from 'react';
import { FIVE_MINUTES_IN_MS } from '@/constants/request';

export const useNewBuildDetector = () => {
  const currentHash = import.meta.env.VITE_BUILD_HASH;
  const [isNewVersionAvailable, setIsNewVersionAvailable] = useState(false);

  const checkForNewBuild = useCallback(async () => {
    if (!currentHash) return;

    try {
      const response = await fetch('/version.json', { cache: 'no-store' });
      if (!response.ok) return;
      const data: unknown = await response.json();
      if (typeof data !== 'object' || data === null || !('version' in data)) return;
      const { version } = data as { version: string };
      if (version && version !== currentHash) {
        setIsNewVersionAvailable(true);
      }
    } catch {
      // ignore network errors silently
    }
  }, [currentHash]);

  useEffect(() => {
    if (!currentHash) return;

    const initialCheckId = setTimeout(checkForNewBuild, 0);

    const intervalId = setInterval(checkForNewBuild, FIVE_MINUTES_IN_MS);

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') checkForNewBuild();
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      clearTimeout(initialCheckId);
      clearInterval(intervalId);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [checkForNewBuild, currentHash]);

  return { isNewVersionAvailable };
};
